<wm-document-data-entity-input
  [form]="form"
  [entity]="entity"
  [activity]="activity"
  [applicationId]="applicationId"
></wm-document-data-entity-input>
